<template>
  <div @click="showSearchJob=false">
    <div class="searchContainer">
      <div class="scrollHeader bg_fff" :class="[windowScrollTop>=188?'showHeader':'']" ref="scrollHeader">
        <div class="content">
          <div class="searchCompose pr" style="box-shadow: none">
            <div class="flex">
              <div class="flex1 flex bg_f9" style="overflow: initial;border-radius: 2px 0 0 2px;">
                <!-- 城市筛选 -->
                <div class="cityBar f_14 color_40 pr">
                  <div class="cityName cursor_p">
                    {{city}}<span class="iconfont iconxuanxiang-shouqi"></span>
                  </div>
                  <div class="city clearfix pa bg_fff">
                    <div class="cityTypeView fl cursor_p">
                      <div class="over">
                        <div :class="['name text_center f_14', cityIndex==='' ? 'current color_40 bg_fff' : 'current color_90']" @click="toggleCityType('')">热门城市</div>
                        <div :class="['name text_center f_14', cityIndex===index ? 'current color_40 bg_fff' : 'current color_90']" v-for="(item, index) in cities" :key="item.group_name" @click="toggleCityType(index)">{{item.group_name}}</div>
                      </div>
                    </div>
                    <div class="cityView fr">
                      <div class="over clearfix">
                        <template v-if="cityIndex===''">
                          <div :class="['item fl cursor_p', item.city_name === city ? 'color_blue current' : '']" v-for="item in hot_cities" :key="item.id" @click="toggleCity(item.city_name)">{{item.city_name}}</div>
                        </template>
                        <template v-else>
                          <div :class="['item fl cursor_p', item.city_name === city ? 'color_blue current' : '']" v-for="item in cities[cityIndex].part_cities" :key="item.id" @click="toggleCity(item.city_name)">{{item.city_name}}</div>
                        </template>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- 搜索框 -->
                <div class="searchBar flex1 clearfix pr" @click.stop="inputFocus(); showSearchJob=true">
                  <!-- 卡片 -->
                  <div class="tagLabel fl color_40 f_14 pr" v-for="(item,index) in keywords" :key="item">
                    <p class="ellipsis">{{item}}</p>
                    <div class="delLabel pa color_blue iconfont iconguanbi cursor_p" @click.stop="delSearch(index)"></div>
                  </div>
                  <!-- <el-input v-model="searchVal" placeholder="请输入职位、公司、学校等关键词" class="searchInput fl f_14 color_40 pr" ref="searchInput"   @keyup.enter.native="searchInput()" @keydown.delete.native="delSearchValue()" @input="checkInput" ></el-input> -->
                  <input type="text" v-model="searchVal" placeholder="请输入职位、公司、学校、专业等关键词" class="searchInput fl f_14 color_40 pr" style="background: transparent;" ref="searchInput"   @keyup.enter="searchInput()" @keydown.delete="delSearchValue()" @input="checkInput" v-if="windowScrollTop>=65" >
                  <div class="searchInput fl f_14 color_40 pr bg_fff" v-if="windowScrollTop<65"></div>

                  <!-- 删除按钮 -->
                  <div class="clearSearch iconfont iconguanbi pa cursor_p" @click.stop="delSearch('all')" v-if="searchVal.length || keywords.length"></div>
                  <!-- 辅助input获取焦点 -->
                  <!-- <div class="inputFocus pa"></div> -->
                </div>

              </div>

              <!-- 搜索按钮 -->
              <div class="searchBtn text_center bg_current color_fff iconfont iconsousuo cursor_p" style="border-bottom-right-radius: 2px;" @click="searchInput()"></div>
            </div>
            <searchFilter :selectedEducation="selectedEducation" :selectedSchool="selectedSchool" :selectedeXperience="selectedeXperience" :contact_directly="contact_directly" :scrollHeaderHeight="scrollHeaderHeight" :latest="latest" position="header"
        @checkFilter="checkFilter" @checkLatest="checkLatest" @clickJobs="clickLeftJobs" @resetFilter="resetFilter" @createSubscribe="createSubscribe" @changeCheck="changeCheck" v-if="windowScrollTop>=188" />
            <!-- 职位列表 -->
            <div class="moreBox pa bg_fff" @click.stop v-if="showSearchJob && windowScrollTop>=188">
              <div class="moreBoxTitle f_14 color_60">
                我的在线职位
                <div class="fr color_60 cursor_p moreJobs" v-if="myPosition.list.length>8" @click="updateBlockStateFun({type: 'jobsPopUpsState', value:true}); showSearchJob=false">查看全部 <span class="iconfont iconyemiantiaozhuan"></span></div>
              </div>
              <template v-if="myPosition.list.length">
                <div class="myPosition clearfix" v-if="myPosition.list.length">
                  <template  v-for="(item,index) in myPosition.list">
                    <div class="Bitem fl" :key="String(index)" v-if="index<8">
                      <div class="item" @click="clickJobs(item,index); showSearchJob=false" data-growing-container data-growing-title='搜索主页在线职位'>
                        <div class="title ellipsis f_14 color_60">{{item.recruit_info.job_post}}</div>
                        <div class="text f_12 color_9c afterText">
                          <span v-if="item.cities">{{item.cities[0]}}</span>
                          <span v-if="item.display_degree">{{item.display_degree}}</span>
                          <span v-if="item.display_experience">{{item.display_experience}}</span>
                          <span v-if="item.salary">{{item.salary}}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
              <p class="f_14 color_9c" v-else style="margin-bottom: 16px">当前暂无在线职位，您可以点击 <a href="/talent/jobedit/create" target="_blank" class="color_blue">去发布</a></p>

              <div class="moreBoxTitle f_14 color_60">热门搜索</div>
              <div class="hotJob clearfix">
                <div class="item fl f_14 color_60 cursor_p" v-for="(item, index) in hotSearch" :key="item" @click="clickHot(item)">
                  {{item}}<span class="iconfont icondahuomiao color_red" v-if="index===0"></span><span class="iconfont iconzhonghuomiao color_red" v-if="index===1"></span><span class="iconfont iconxiaohuomiao color_red" v-if="index===2"></span>
                </div>
              </div>

              <template v-if="searchHistory.length">
                <div class="moreBoxTitle f_14 color_9c clearfix">
                  历史搜索 <div class="fr iconfont iconGroup3 color_9c cursor_p" @click="clearHistory()"></div>
                </div>
                <div class="searchHistory clearfix">
                  <template v-for="(item,index) in searchHistory">
                    <div class="item fl f_14 color_9c cursor_p ellipsis" :key="String(index)" @click="clickHistory(item)" v-if="index<=9">{{item.name}}</div>
                  </template>

                </div>
              </template>
            </div>
          </div>
          <!-- 个人信息 -->
          <div class="person">
            <div class="header-personal-center">
              <div class="header-personal-center-menu dropdown pull-right pr">
                <img class="person-icon" :src="userInfo.wechat_avatar || headImgList.round[isNaN(userTokenNumber)?0:userTokenNumber%5]" />
                <ul class="dropdown-menu bg_fff">
                  <li>
                    <a class='flex-c' href="/talent/users" target="_blank" style="margin:0 18px; padding:3px 2px !important; border-bottom: 1px solid #ececec;">
                      <span class="menu-item-icon" style="margin-left:18px;margin-right:23px;">
                        <img src="https://files.wondercv.com/searchResume_pc/setup-icon.png" class="pr" width="16px" style="margin-left:-4px;top:-1;">
                      </span>
                      <span class="flex1">账户设置</span>
                    </a>
                  </li>
                  <li>
                    <a class='flex-c' href="/talent/userinfo" target="_blank" style="margin:0 18px; padding:3px 2px !important; border-bottom: 1px solid #ececec;">
                      <span class="menu-item-icon">
                        <img src="https://files.wondercv.com/userinfo-icon.png" width="16px" style="margin-left:-4px;">
                      </span>
                      <span class="flex1">个人信息</span>
                    </a>
                  </li>
                  <li>
                    <a class='flex-c' href="/talent/company" target="_blank" style="margin:0 18px; padding:3px 2px !important; border-bottom: 1px solid #ececec;">
                      <span class="menu-item-icon">
                        <img src="https://files.wondercv.com/company-icon.png" width="16px" style="margin-left:-4px;">
                      </span>
                      <span class="flex1">公司信息</span>
                    </a>
                  </li>
                  <li>
                    <a class='flex-c' href="/talent/greet" target="_blank">
                      <span class="menu-item-icon">
                        <img src="https://files.wondercv.com/hr_frontend/recruitment-settings-icon.png" width="16px" style="margin-left:-4px;">
                      </span>
                      <span class="flex1">招聘设置</span>
                    </a>
                  </li>
                  <li>
                    <a class='flex-c' href="/talent/order" target="_blank">
                      <span class="menu-item-icon">
                        <img src="https://files.wondercv.com/searchResume_pc/my-order-icon.png" width="16px" style="margin-left:-4px;">
                      </span>
                      <span class="flex1">我的订单</span>
                    </a>
                  </li>
                  <li style="border-top: 6px solid #f9f9f9; border-bottom: 6px solid #f9f9f9; height: 64px;">
                    <a class='flex-c' href="/jobs/">
                      <span class="menu-item-icon">
                        <img src="https://files.wondercv.com/change-icon.png" width="16px" style="margin-left:-4px;top:-1;">
                      </span>
                      <span class="flex1">切换求职者身份</span>
                    </a>
                  </li>
                  <li>
                    <a class='flex-c' href="javascript:;" @click="sign_out">
                      <span class="menu-item-icon" style="margin-left:19px;margin-right:21px;">
                        <img src="https://files.wondercv.com/searchResume_pc/signout-icon.png" width="17px" class="pr" style="margin-left:-4px;">
                      </span>
                      <span class="flex1">退出登录</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 顶部搜索框 -->
      <div class="searchCompose pr">

        <!-- 搜索框功能 -->
        <div class="flex">
          <div class="flex1 flex bg_fff" style="overflow: inherit;border-top-left-radius: 6px;">
            <!-- 城市筛选 -->
            <div class="cityBar f_14 color_40 pr">
              <div class="cityName cursor_p bg_city">
                  {{city}}<span class="iconfont iconxuanxiang-shouqi"></span>
              </div>
              <div class="city clearfix pa bg_fff">
                <div class="cityTypeView fl cursor_p">
                  <div class="over">
                    <div :class="['name text_center f_14', cityIndex==='' ? 'current color_40 bg_fff' : 'current color_90']" @click="toggleCityType('')">热门城市</div>
                    <div :class="['name text_center f_14', cityIndex===index ? 'current color_40 bg_fff' : 'current color_90']" v-for="(item, index) in cities" :key="item.group_name" @click="toggleCityType(index)">{{item.group_name}}</div>
                  </div>
                </div>
                <div class="cityView fr">
                  <div class="over clearfix">
                    <template v-if="cityIndex===''">
                      <div :class="['item fl cursor_p', item.city_name === city ? 'color_blue current' : '']" v-for="item in hot_cities" :key="item.id" @click="toggleCity(item.city_name)">{{item.city_name}}</div>
                    </template>
                    <template v-else>
                      <div :class="['item fl cursor_p', item.city_name === city ? 'color_blue current' : '']" v-for="item in cities[cityIndex].part_cities" :key="item.id" @click="toggleCity(item.city_name)">{{item.city_name}}</div>
                    </template>
                  </div>
                </div>

              </div>
            </div>
            <!-- 搜索框 -->
            <div class="searchBar flex1 clearfix pr" @click.stop="inputFocus(); showSearchJob=true">
              <!-- 卡片 -->
              <div class="tagLabel fl color_40 f_14 pr" v-for="(item,index) in keywords" :key="item">
                <p class="ellipsis">{{item}}</p>
                <div class="delLabel pa color_blue iconfont iconguanbi cursor_p" @click.stop="delSearch(index)"></div>
              </div>
              <input type="text" v-model="searchVal" placeholder="请输入职位、公司、学校、专业等关键词" class="searchInput fl f_14 color_40 pr" ref="searchInput"  @keyup.enter="searchInput()" @keydown.delete="delSearchValue()" @input="checkInput" v-if="windowScrollTop<65" >
              <div class="searchInput fl f_14 color_40 pr" v-if="windowScrollTop>=65"></div>
              <!-- 删除按钮 -->
              <div class="clearSearch iconfont iconguanbi pa cursor_p" @click.stop="delSearch('all')" v-if="searchVal.length || keywords.length"></div>
            </div>

          </div>
          <!-- 搜索按钮 -->
          <div class="searchBtn text_center bg_current color_fff iconfont iconsousuo cursor_p" @click="searchInput()"></div>
        </div>
        <!-- 筛选菜单 -->
        <searchFilter :selectedEducation="selectedEducation" :selectedSchool="selectedSchool" :selectedeXperience="selectedeXperience" :contact_directly="contact_directly" @checkFilter="checkFilter" :scrollHeaderHeight="scrollHeaderHeight"
        :latest="latest" @checkLatest="checkLatest" @clickJobs="clickLeftJobs" @resetFilter="resetFilter" @createSubscribe="createSubscribe" @changeCheck="changeCheck" />

        <!-- 职位列表 -->
        <div class="moreBox pa bg_fff" @click.stop v-if="showSearchJob">
          <div class="moreBoxTitle f_14 color_60">
            我的在线职位
            <div class="fr color_60 cursor_p moreJobs" v-if="myPosition.list.length>8" @click="updateBlockStateFun({type: 'jobsPopUpsState', value:true});showSearchJob=false">查看全部 <span class="iconfont iconyemiantiaozhuan"></span></div>
          </div>
          <template v-if="myPosition.list.length">
            <div class="myPosition clearfix" v-if="myPosition.list.length">
              <template  v-for="(item,index) in myPosition.list">
                <div class="Bitem fl" :key="String(index)" v-if="index<8">
                  <div class="item" @click="clickJobs(item,index); showSearchJob=false" data-growing-container data-growing-title='搜索主页在线职位'>
                    <div class="title ellipsis f_14 color_60">{{item.recruit_info.job_post}}</div>
                    <div class="text f_12 color_9c afterText">
                      <span v-if="item.cities">{{item.cities[0]}}</span>
                      <span v-if="item.display_degree">{{item.display_degree}}</span>
                      <span v-if="item.display_experience">{{item.display_experience}}</span>
                      <span v-if="item.salary">{{item.salary}}</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <p class="f_14 color_9c" v-else style="margin-bottom: 16px">当前暂无在线职位，您可以点击 <a href="/talent/jobedit/create" target="_blank" class="color_blue">去发布</a></p>

          <div class="moreBoxTitle f_14 color_60">热门搜索</div>
          <div class="hotJob clearfix">
            <div class="item fl f_14 color_60 cursor_p" v-for="(item, index) in hotSearch" :key="item" @click="clickHot(item)">
              {{item}}<span class="iconfont icondahuomiao color_red" v-if="index===0"></span><span class="iconfont iconzhonghuomiao color_red" v-if="index===1"></span><span class="iconfont iconxiaohuomiao color_red" v-if="index===2"></span>
            </div>
          </div>

          <template v-if="searchHistory.length">
            <div class="moreBoxTitle f_14 color_9c clearfix">
              历史搜索 <div class="fr iconfont iconGroup3 color_9c cursor_p" @click="clearHistory()"></div>
            </div>
            <div class="searchHistory clearfix">
              <template v-for="(item,index) in searchHistory">
                <div class="item fl f_14 color_9c cursor_p ellipsis" :key="String(index)" @click="clickHistory(item)" v-if="index<=9">{{item.name}}</div>
              </template>

            </div>
          </template>
        </div>

      </div>

      <div class="flex">

        <!-- 左侧列表 -->
        <div class="talentPage flex1-nohide">
          <talentList ref="talentList" :keywordsBat="keywordsBat" @pageChange="pageChange" :isLoading="isLoading" :isSearchData="true" :isFirstQuery="isFirstQuery" @getDetail="getDetail" :jobId="job_id" />
        </div>

        <!-- 右侧筛选项 -->
        <!-- <list-left
        :selectedEducation="selectedEducation" :selectedSchool="selectedSchool" :selectedeXperience="selectedeXperience" @checkFilter="checkFilter" :searchPositionIndex="searchPositionIndex" :scrollHeaderHeight="scrollHeaderHeight"
        :latest="latest" @checkLatest="checkLatest" @clickJobs="clickLeftJobs" @resetFilter="resetFilter"
        ></list-left> -->

      </div>

      <!-- 简历详情 -->
      <resume-detail-box :type="'searchList'" ref="resumeDetailBox" @getDetail="getDetail" :notfindResume="notfindResume"  @hideDetails="hideDetails" :favoritesId="favoritesId" v-if="showDetail"/>

      <!-- 完善信息弹层 -->
      <userinfo-tips @confirmToRecruitInfos="hideDetails" />

      <!-- 在线职位弹窗 -->
      <jobsPopUps v-if="jobsPopUpsState" @clickJobs="clickLeftJobs" />

<!--      <div class="wecaht cursor_p">-->
<!--        <img class="icon" src="https://files.wondercv.com/hr_frontend/wechat-icon.png" alt="">-->
<!--        <div class="wx-hover-main text_center">-->
<!--          <img src="https://files.wondercv.com/searchResume_pc/qrCode.png" alt="超级候选人小程序，微信上也能查找优秀人才">-->
<!--          <p class="wx-title f_14 color_40">超级候选人小程序</p>-->
<!--          <p class="wx-msg color_9c f_12">微信上也能查找优秀人才</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
// import ListLeft from '@/components/searchList/ListLeft'
import talentList from '@/components/searchList/talentList'
import ResumeDetailBox from '@/components/resumeDetailBox/index'
import userinfoTips from '@/components/block/userinfoTips'
import jobsPopUps from '@/components/recommend/jobsPopUps'

import searchFilter from '@/components/searchList/searchFilter'

import { isitRedundant, isToggleUser, checkUserState, get_tUser, toLogin, updateJWT } from '@/utils/utils';
import { headImgList } from '@/utils/static'
import { queryFilter, checkCity } from './ListFilter'

// 所有接口
import actions from '@/actions/index'
// 搜索的mixins
import searchMixins from '@/mixins/search/config'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'searchContainer',
  mixins:[searchMixins],
  data(){
    return {
      userJWT:{},
      userInfo:{},
      cityIndex:'',
      city:'全国', //当前选择的城市
      keywords:[], //当前选择的keyword
      keywordsBat:[],//当前选择的keyword-备份
      searchVal:'', //搜索框value
      isComposing:false, //搜索框值，仅做监听

      pageNo:1, //当前第几页
      pageSize:15,//每页15条数据

      // resumeListData:{
      //   resumes:[],
      //   total_count:0
      // },//简历列表

      latest:0,//查看最新简历，0，1 选中和取消
      selectedEducation:[], //学历选中数据
      selectedSchool:[],  //学校选中数据
      selectedeXperience:[], //经验选中数据
      contact_directly: null,   // 筛选可查看电话的职位
      isLoading:true,//是否在请求列表
      isQueryEnd:true,//是否请求完毕
      isFirstQuery:true,//是否是第一次请求

      showDetail:false,

      searchHistory:[],//搜索历史
      keyword_hit:[], //单个简历的高亮数据

      job_id:'',//匹配的职位id
      searchPositionIndex: -1,//左侧搜索上点击的第几个
      favoritesId:'', //是否自动收藏
      notfindResume:false,//是否未找到简历
      headImgList: headImgList,
      userTokenNumber:0,
      scrollHeaderHeight:0, //获取搜索框高度
      scrollTopNumber:0,//每次滚动多少

      showSearchJob: false, //是否显示搜索框里边的职位
      showSearchJobScrollHeight: 0, //显示时的高度
      jobType:{
        '中专':'中专,高中,大专,本科,硕士,博士,MBA',
        '高中':'高中,大专,本科,硕士,博士,MBA',
        '大专':'大专,本科,硕士,博士,MBA',
        // '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },
      hotSearch:['产品经理','产品运营','前端开发','JAVA','Python','数据分析'], //热门搜索
      isInputSearch: false, // 是否是通过回车 或者 点击搜索按钮 执行的搜索，因为这种条件下才执行反选操作
      cacheQueryInfo: null
    }
  },
  computed:{
    ...mapState('block',['userInfoState', 'bodyClientHeight', 'windowScrollTop', 'windowInnerHeight', 'jobsPopUpsState']),
    ...mapState('resumeDetails',['resumeDetailToken', 'resumeListObj', 'resumeDetail', 'resumeDetailOptions', 'myPosition', 'listOptions', 'searchListObj', 'listPageNumber']),
  },
  components:{
    // 'list-left':ListLeft,
    talentList,
    ResumeDetailBox,
    'userinfo-tips':userinfoTips,
    searchFilter,
    jobsPopUps
  },
  beforeCreate(){
    let {
      keyword='', //搜索关键词
    } = this.$route.query;
    if(!keyword){
      this.$router.replace({ path: '/talent/search' })
      return false;
    }
  },
  async created(){
    this.userJWT = get_tUser();

    this.updateRoutePageName(this.$route.name);
    this.created();

    if(this.userJWT.t){
      // 获取职位列表
      this.getMyPosition();
    }
  },
  mounted(){
    //同步当前详情页
    this.updateSharePage('searchList');
  },
  beforeDestroy(){
    //同步当前详情页
    this.updateSharePage('');
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','updateSharePage','updagreBodyClient', 'updateBlockStateFun']),
    ...mapMutations('resumeDetails',['updateRoutePageName', 'updateResumeDetailToken', 'updateResumeListObj', 'resetResumeListObj', 'updateResumeDetail', 'updateListOptions', 'updateSearchListObj','updateDownloadResumeInfo', 'updateShowDetailFlag', 'updateSearchResumeBasic']),
    ...mapActions('resumeDetails',['getMyPosition']),

    // 同顶部created
    async created(){
      let {
        keyword='', //搜索关键词
        // pageNo=1, //分页
        city='',
        latest=0, //是否更新
        education='', //学历
        schoolType='', //院校
        workYear='', //工作经验
        detailToken='', //简历预览的token
        favoritesId='', //是否自动收藏
        job_id='', //期望默认的职位id
        searchPositionIndex=-1, //保存点击的第几个职位
        abc='',
        contact_directly=''
      } = this.$route.query;
      this.contact_directly = contact_directly ? true : null
      //没有关键词，返回搜索主页 或者 判断url参数是否完整
      if(!keyword || !queryFilter(this.$route.query) ){
        this.$router.replace({ name: 'talentSearchIndex' })
        return false;
      }
      //整理keywords
      let keywords = decodeURIComponent(keyword);
      keywords = keyword.split(',').filter(item=>item);
      this.keywords = keywords;
      this.keywordsBat = [...keywords];
      //整理分页
      // this.pageNo = pageNo || 1;
      //整理是否最新
      this.latest = latest==='1'?1:0;
      //整理工作经验
      this.selectedeXperience = workYear ==='不限' ? [] : workYear.split(',').filter(item=>item);
      //整理院校
      this.selectedSchool = schoolType ==='不限' ? [] : schoolType.split(',').filter(item=>item);
      //整理学历
      this.selectedEducation = education ==='不限' ? [] : education.split(',').filter(item=>item);

      //更新搜索参数到vuex
      this.updateSearchListObj({
        selectedeXperience: this.selectedeXperience,
        keywordsBat: this.keywordsBat, //当前选择的keyword-备份
        keyword_seg:[], //列表分词数据
        keyword_hit:[], //列表搜索关键词数据
      })

      //同步顶部详情token
      this.updateResumeDetailToken(detailToken);

      //增加历史记录
      let searchHistory = localStorage.getItem('searchHistory');
      this.searchHistory =  searchHistory ? JSON.parse(searchHistory) : [];
      // await actions.utils.checkJWT();

      let user = get_tUser();
      if(!user.h_t){
        // 不是hr
        this.toggleUserInfoState(false)
        this.city = '全国';
      }else{
        // 获取默认头像
        this.userTokenNumber = user.t.charAt(user.t.length-1) || 0;
        //更新是否完善信息(状态库)
        let userInfo = await actions.hr_accounts.getUserinfo();
        this.userInfo = userInfo;
        this.toggleUserInfoState(userInfo)
        if(userInfo.city_name && !city){
          this.city = userInfo.city_name;
        }else{
          //整理城市
          this.city = checkCity(city) ? city : '全国';
        }
      }

      //是否自动收藏
      this.favoritesId = favoritesId;
      // 期望默认的职位id
      this.job_id = job_id;

      //保存点击的职位index
      this.searchPositionIndex = searchPositionIndex;

      //整理uri格式
      let url = window.location.href.replace(/,/g, "%2C").split('favoritesId')[0];
      history.replaceState(null, null,url)
      //获取搜索列表
      this.getList();

    },
    // 创建订阅
    async createSubscribe () {

      try {

        let params = {
          keyword: this.keywords.join(' '),
          expected_location: this.city,
          degree: this.selectedEducation.join(','),
          school_tags: this.selectedSchool.join(','),
          experiences: this.selectedeXperience.join(',')
        }

        let res = await actions.resumes.create_subscribe(params)
        if (res.code === 1000) {
          this.$message({
            message: '添加订阅成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      }

    },
    //【搜索】输入框删除监控
    delSearchValue(){
      if(this.isComposing){
        return false;
      }
      if(!this.searchVal){
        this.delSearch(this.keywords.length-1);
      }
      //删除聚焦
      setTimeout(() => {
        this.inputFocus();
      }, 10);
    },
    //【搜索】输入框回车搜索
    searchInput(){
      if(!this.searchVal){
        return false;
      }
      //判断是否有重复搜索词 重复数据，清空搜索
      if(isitRedundant(this.searchVal, this.keywords)){
        this.searchVal = '';
        return false;
      }
      // 添加一项搜索tag
      this.keywords.push(this.searchVal.replace(/(^\s*)|(\s*$)/g,""));
      this.keywordsBat = [...this.keywords];
      // 清空搜索
      this.searchVal = '';
      this.job_id = '';
      // 是回车或者点击搜索按钮执行的搜索
      this.isInputSearch = true
      //重置参数，请求接口
      this.resetQuery();
    },
    //【搜索】聚焦输入框
    inputFocus(){
      this.$refs.searchInput.focus();
      this.showSearchJobScrollHeight = this.windowScrollTop;
      // this.$refs.searchInput.$el.children[0].focus();
      // .$el.children[0].focus();
    },
    //【搜索】删除某一个标签 或者 删除全部
    delSearch(index){
      if(index === 'all'){
        // 删除全部（不需要刷新数据）
        this.keywords = [];
        this.searchVal = '';
        // 聚焦输入框
        setTimeout(() => {
          this.inputFocus();
        }, 10);
      }else{
        // 删除某一个标签，需要刷新数据
        this.keywords.splice(index,1);
        //只有最后一张卡片不更新url
        if(this.keywords.length){
          this.keywordsBat = [...this.keywords];
          this.isInputSearch = true
          //重置参数，请求接口
          this.resetQuery();
        }
      }
    },
    //【城市】更换城市筛选的type
    toggleCityType(index){
      this.cityIndex = index;
    },
     //【城市】更换城市
    toggleCity(name){
      this.city = name;
      //重置参数，请求接口
      this.resetQuery();
    },
    //获取简历列表
    async getList(searchType){

      if(!this.keywordsBat.length){
        this.$router.replace({ path: '/talent/search' })
        return false;
      }

      //把备份的keywords回退回去
      this.keywords = [...this.keywordsBat];
      //增加历史记录
      this.addHistory();

      //未完成不允许加载
      if(!this.isQueryEnd){
        return false;
      }
      let queryLoading = null;
      if(!this.isFirstQuery){
        queryLoading =  this.$message({
          message: '正在加载...',
          iconClass:'el-icon-loading',
          duration:0,
        });
      }else{
        //返回顶部
        scrollTo(0,0);
        this.showSearchJob = false;
      }

      // 调用缓存接口
      let queryInfo = null
      if (searchType === 'scroll') {
        queryInfo = this.cacheQueryInfo
      } else {

        let params = {
          query: this.keywordsBat.join(' ')
        }
        try {
          let res = await actions.ml.cv_search_queries(params)
          if (res.code === 1000) {
            // 返回值作为获取简历列表接口参数
            queryInfo = res.data.query_info
            this.cacheQueryInfo = res.data.query_info
            // 根据返回值 反选筛选项（地区、学历、院校、工作经验）
            this.isInputSearch && this.unifyFilterMenu(res.data.query_info)
          }
        } catch (e) {
          console.log(e)
        }

      }


      // {'海外QS前100', '211', '类211', '985', '一流大学建设高校B类', '一流大学建设高校A类', '一流学科建设高校'}
      let school_tags = ''
      if(this.selectedSchool.length == 1) {
        school_tags =  this.selectedSchool[0] == '海外前100' ? '海外QS前100' : this.selectedSchool.toString()
      }
      else if(this.selectedSchool.length == 2){
        if(this.selectedSchool.includes('211') && this.selectedSchool.includes('985')){
          school_tags = '211,类211,985,一流大学建设高校B类,一流大学建设高校A类,一流学科建设高校'
        } else {
          school_tags = [...this.selectedSchool,'海外QS前100'].filter(item => item !== '海外前100').toString()
        }
        // school_tags =  this.selectedSchool[0]==='985' || this.selectedSchool[0]==='211' ? '211,类211,985,一流大学建设高校B类,一流大学建设高校A类,一流学科建设高校' : '海外QS前100'
      }else if(this.selectedSchool.length == 3){
        school_tags =  '211,类211,985,一流大学建设高校B类,一流大学建设高校A类,一流学科建设高校,海外QS前100'
      }
      console.log(this.selectedEducation,"==================>selectedEducation")
      let queryData = {
        parsed_query: queryInfo,
        keyword:this.keywordsBat.join(' '), //搜索关键词
        from:(this.pageNo-1) * this.pageSize, //起始数据
        size:this.pageSize, //每页条数
        experiences: this.selectedeXperience.join(','), //工作经验 多个则用,隔开
        degree: this.selectedEducation.join(','), //学历
        school_tags, //学校
        latest:this.latest, //是否最新
        expected_location:this.city === '全国' ? '' : this.city,
        contact_directly: this.contact_directly ? this.contact_directly : null,
        platform: 'pc_browser',
      }

      //更新请求状态
      this.isQueryEnd = false;
      this.isLoading = true;
      //请求列表
      // actions.resumes.getResumes(queryData).then(res=>{
      actions.resumes.newGetResumes(queryData).then(res=>{
        this.isLoading = false;
        if(!this.isFirstQuery && queryLoading){
          queryLoading.close();
        }
        //更新当前路由名字
        this.updateRoutePageName(this.$route.name);

        if(res.code ===1000){
          let { resumes } = res.data;
          // console.log(resumes,"====================>resumes")
          let tokenIndex = -1;
          //方便读取当前第几个
          let resumeIndex = -1;
          let tokenList = []
          resumes.forEach((item, index) => {
            tokenList.push(item.resume._source.token)
          })
          // 先加载列表数据，获取简历各个状态之后再修改一次列表数据
          //判断是下一页
          let isNextPage = false;
          if(this.listPageNumber > this.listOptions.page){
            //同步顶部详情token
            this.updateResumeDetailToken(resumes[0].resume._source.token);
            resumeIndex = this.listOptions.resumeIndex;
            this.isNextPage = true;
          }

          let resumeListObj = JSON.parse(JSON.stringify(this.resumeListObj))
          let nowResumeList = this.pageNo === 1 ? [] : resumeListObj.searchList;
          let resumeList = nowResumeList.concat(resumes);
          //合并列表
          // resumeListObj.searchList = res.data.resumes;
          this.pageNo === 1 && this.updateResumeListObj({key:'searchList', value: resumeList});

          //更新搜索参数到vuex
          this.updateSearchListObj({
            ...this.searchListObj,
            keyword_seg: res.data.keyword_seg || [], //列表分词数据
          })

          if(this.favoritesId){
            this.$refs.talentList.resumeCollect("",tokenIndex,this.favoritesId);
            this.favoritesId = '';
          }
          //列表数据同不到vuex
          this.updateListOptions({
            resumeIndex,
            page: this.pageNo,
            page_size: this.pageSize,
            total_count: res.data.total_count,
          });
          //如果有简历token，自动弹出token
          if(this.resumeDetailToken){
            this.getDetail({token:this.resumeDetailToken, isNextPage: this.isNextPage, item: resumeListObj.searchList[resumeIndex]});
          }
          if(this.isFirstQuery){
            //返回顶部
            scrollTo(0,0);
          }
          setTimeout(() => {
            //获取body高度
            this.getBodyClient();
            this.isFirstQuery = false;
            this.isQueryEnd = true;
          }, 100);
          actions.resumes.get_resume_detail({token_list: tokenList}).then(detailRes => {
            if (detailRes.code === 1000) {
              let { data } = detailRes
              let newResumes = resumes.map((item, index) => {
                return {...item, ...data[index]}
              })
              //如果是进入时就有token
              if(this.resumeDetailToken){
                resumes.forEach((item,index)=>{
                  if(this.favoritesId == item.resume._source.token){
                    tokenIndex = index
                  }
                  //同步当前是第几个元素
                  if(this.resumeDetailToken == item.resume._source.token){
                    resumeIndex = index
                  }
                })
              }

              //判断是下一页
              let isNextPage = false;
              if(this.listPageNumber > this.listOptions.page){
                //同步顶部详情token
                this.updateResumeDetailToken(newResumes[0].resume._source.token);
                resumeIndex = this.listOptions.resumeIndex;
                this.isNextPage = true;
              }

              let resumeListObj = JSON.parse(JSON.stringify(this.resumeListObj))
              let nowResumeList = this.pageNo === 1 ? [] : resumeListObj.searchList;
              let resumeList = nowResumeList.concat(newResumes);
              //合并列表
              // resumeListObj.searchList = res.data.resumes;
              this.updateResumeListObj({key:'searchList', value: resumeList});

              //更新搜索参数到vuex
              this.updateSearchListObj({
                ...this.searchListObj,
                keyword_seg: res.data.keyword_seg || [], //列表分词数据
              })

              if(this.favoritesId){
                this.$refs.talentList.resumeCollect("",tokenIndex,this.favoritesId);
                this.favoritesId = '';
              }
              //列表数据同不到vuex
              this.updateListOptions({
                resumeIndex,
                page: this.pageNo,
                page_size: this.pageSize,
                total_count: res.data.total_count,
              });
              //如果有简历token，自动弹出token
              if(this.resumeDetailToken){
                this.getDetail({token:this.resumeDetailToken, isNextPage: this.isNextPage, item: resumeListObj.searchList[resumeIndex]});
              }
              if(this.isFirstQuery){
                //返回顶部
                scrollTo(0,0);
              }
              setTimeout(() => {
                //获取body高度
                this.getBodyClient();
                this.isFirstQuery = false;
                this.isQueryEnd = true;
              }, 100);
            }
          })
        }else{
          //接口失败，取消loading状态
          this.isFirstQuery = false;
          this.isQueryEnd = true;
          queryLoading && queryLoading.close();
        }
      })
    },
    // 反选筛选项
    unifyFilterMenu (data) {
      //有值就覆盖，没有值不做处理

      // 城市
      if (data.location && data.location.length) {
        this.city = data.location[0]
      }

      // 学历
      if (data.degree && data.degree.length) {
        this.selectedEducation = data.degree
      }

      // 院校
      if (data.school_tag && data.school_tag.length) {
        let schoolTag = data.school_tag
        let schoolSelect = []
        if (schoolTag.includes('211') || schoolTag.includes('985')) {
          schoolSelect.push('985/211')
        }
        if (schoolTag.includes('海外QS前100')) {
          schoolSelect.push('海外前100')
        }
        schoolSelect.length && (this.selectedSchool = schoolSelect)
      }

      // 身份
      if (data.profession_identity && data.profession_identity.length) {
        // 清空工作经验筛选
        this.removeItemArray(this.selectedeXperience, '在读')
        this.removeItemArray(this.selectedeXperience, '应届生')
        // 再添加
        let identity = data.profession_identity
        if (identity.includes('在读')) {
          this.selectedeXperience.push('在读')
        }
        if (identity.includes('应届')) {
          this.selectedeXperience.push('应届生')
        }
      }

      // 经验
      if (data.work_year.lower_bound && data.work_year.upper_bound) {
        // 清空工作经验筛选
        this.removeItemArray(this.selectedeXperience, '1-3年')
        this.removeItemArray(this.selectedeXperience, '3-5年')
        this.removeItemArray(this.selectedeXperience, '5-10年')
        this.removeItemArray(this.selectedeXperience, '10年以上')
        // 再添加
        // 1-3年
        this.unifyFilterMenuExperience(1, 3, data.work_year.lower_bound, data.work_year.upper_bound, '1-3年')
        // 3-5年
        this.unifyFilterMenuExperience(3, 5, data.work_year.lower_bound, data.work_year.upper_bound, '3-5年')
        // 5-10年
        this.unifyFilterMenuExperience(5, 10, data.work_year.lower_bound, data.work_year.upper_bound, '5-10年')
        // 10年以上
        this.unifyFilterMenuExperience(10, 100, data.work_year.lower_bound, data.work_year.upper_bound, '10年以上')
      }

      // 每次反选完成，都需要重置
      this.isInputSearch = false
    },
    // 反选工作经验
    unifyFilterMenuExperience (start1, end1, start2, end2, val) {
      let arr1 = this.generateArray(start1, end1)
      let arr2 = this.generateArray(start2, end2)
      let flag = this.checkIntersectionArray(arr1, arr2)
      flag && this.selectedeXperience.push(val)
    },
    // 删掉数组里的某个值
    removeItemArray (arr, val) {
      let index = arr.indexOf(val)
      if (index > -1) arr.splice(index, 1)
    },
    // 检查两个数组是否有交集
    checkIntersectionArray (arr1, arr2) {
      return (arr1.length + arr2.length) !== Array.from(new Set([...arr1,...arr2])).length
    },
    // 生成一个有序数组
    generateArray (start, end) {
      return Array.from(new Array(end + 1).keys()).slice(start)
    },
    pageChange(pageNo){
      //修改分页条数
      this.pageNo = pageNo;
      //同步url
      this.encodeURI();
      //获取列表数据
      this.getList();
    },

    // 左侧方法
    //切换是否查看最新简历
    checkLatest(){
      this.latest = this.latest ? 0 : 1;
      //重置参数，请求接口
      this.resetQuery();
    },
    // 支持查看电话的筛选
    changeCheck(val) {
      this.contact_directly = val
      //重置参数，请求接口
      this.resetQuery();
    },
    //切换左侧筛选
    checkFilter(options){
      console.log(options);
      let { type, item} = options;
      let list = [...this[type]];
      if(options.item === '不限'){
        this[type] = [];
      }else{
        let hasItem = false;
        let hasItemIndex = 0;
        this[type].forEach((sitem, index)=>{
          if(sitem === item){
            hasItem = true
            hasItemIndex = index;
          }
        })
        if(hasItem){
          this[type].splice(hasItemIndex,1);
        }else{
          this[type].push(item);
        }
      }
      if(list.length !== this[type].length){
        //重置参数，请求接口
        this.resetQuery();
      }
    },
    //重置左侧筛选
    resetFilter(){
      this.latest = 1;
      //整理工作经验
      this.selectedeXperience = [];
      //整理院校
      this.selectedSchool = [];
      //整理学历
      this.selectedEducation = [];
      //重置参数，请求接口
      this.resetQuery();
    },
    //获取简历详情
    async getDetail(options){
      // 将列表简历的基本信息存入vuex
      options.item && this.updateSearchResumeBasic(options.item)
      // console.log(options.item,"======================>item");
      //更新搜索参数到vuex
      this.updateSearchListObj({
        ...this.searchListObj,
        keyword_hit: options.keyword_hit || [], //列表搜索关键词数据
      })

      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          this.pageChange(1);
          return false;
        },
      });
      let user = get_tUser();
      if(user.h_t){
        //获取职位列表
        this.getMyPosition({job_id: this.job_id});
      }
      // 显示骨架图loading
      this.updateShowDetailFlag(false)
      this.showDetail = true;
      actions.resume_permissions.v2resumedetails({token: options.token}).then(res=>{
        if(res.code === 80139 || res.code === 80120 || res.code === 1000 || res.code === 80121){
          // 如果是翻页，需要同步当前第几个
          if(options.type=== 'prev' || options.type==='next' || options.isNextPage){
            let resumeIndex = options.type==='next' || options.isNextPage ? this.listOptions.resumeIndex+1 : this.listOptions.resumeIndex-1;
            //同步分页数据
            this.updateListOptions({
              ...this.listOptions,
              resumeIndex: resumeIndex,
            });
          }
        }
        if(res.code === 80139 || res.code === 80120 || res.code === 80121){
          this.notfindResume = true;
          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)
          return false;
        }
        this.notfindResume = false;
        if(res.code === 1000){
          this.updateDownloadResumeInfo(res.data)
          //数据同步到vuex中
          this.updateResumeDetail(res.data);
          // console.log(res.data)
          // 高亮处理
          this.$refs.resumeDetailBox && this.$refs.resumeDetailBox.highlightFunc()
          //简历详情相关url 及 参数，用作收藏等交互
          this.updateResumeDetailToken(options.token);
          this.encodeURI({token: options.token});
          this.updateShowDetailFlag(true)
          //显示弹层
          // this.showDetail = true;

        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })

    },
    //隐藏详情
    hideDetails(){
      this.showDetail = false;
      //更新url
      this.encodeURI({token: ''});

      //重置详情的token相关数据
      this.updateResumeDetailToken('');

      // 页面结构排序
      this.sections_position = [];
      // 其他排序
      this.others_position = [];
      document.body.style.position = 'initial'
      document.body.style.overflow = 'initial'
    },

    //更新路由
    encodeURI(options){
      let { abc } = this.$route.query;

      let url = window.location.origin + window.location.pathname + '?';
      //更新搜索值
      let keywords = this.keywordsBat.join(',');
      keywords = encodeURIComponent(keywords);
      url+= keywords.length ? `keyword=${keywords}&` : '';
      //更新分页
      url += `pageNo=${this.pageNo}&`
      //更新最新简历
      url += `latest=${this.latest}&`
      //更新城市
      url += `city=${this.city}&`
      // 更新学历
      url += `education=${this.selectedEducation.join('%2C')}&`
      // 更新院校
      url += `schoolType=${this.selectedSchool.join('%2C')}&`
      // 更新工作经验
      url += `workYear=${this.selectedeXperience.join('%2C')}&`
      //更新简历详情
      url += `detailToken=${options ? options.token : ''}&`
      //更新简历详情Token
      url += `abc=${abc || ''}&`
      //更新是否支持查看电话
      url += `contact_directly=${this.contact_directly || ''}&`
      // 更新 job_id
      url += `job_id=${this.job_id || ''}&`

      // let query = {
      //   keyword: keywords.length ? keywords : '',
      //   pageNo: this.pageNo,
      //   latest: this.latest,
      //   city: this.city,
      //   education: this.selectedEducation.join('%2C'),
      //   schoolType: this.selectedSchool.join('%2C'),
      //   workYear: this.selectedeXperience.join('%2C'),
      //   detailToken: options ? options.token : '',
      //   abc: abc || '',
      //   contact_directly: this.contact_directly || '',
      //   job_id: this.job_id || ''
      // }
      // this.$router.push({query})
      // 添加一条历史记录，不刷新页面 history.pushState(state, title, url)
      history.pushState(null, null, url);
    },
    //重置参数，请求接口
    resetQuery(){
      this.pageNo = 1;
      this.encodeURI();
      //重置列表数据
      this.resetResumeListObj();

      this.isLoading = true;//是否在请求列表
      this.isQueryEnd = true;//是否请求完毕
      this.isFirstQuery = true;//是否是第一次请求

      this.getList();
      //重置左侧职位选中index
      this.searchPositionIndex = -1;
    },
    //增加历史记录
    addHistory(){
      let keywords = this.keywordsBat.join(' ');
      //判断当前搜索项以前搜索过没有
      let haskeyword = this.searchHistory.filter((item) => {
        return item.name === keywords;
      })
      if (!haskeyword.length) {
        //搜索记录最前边，增加一条记录
        this.searchHistory.unshift({
          name:keywords,
          keywords:[...this.keywordsBat],
        });
        this.searchHistory.length = this.searchHistory.length>10 ? 10 : this.searchHistory.length;
        //更新到本地
        localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
      }
    },
    checkInput(e){
      this.isComposing = e.isComposing;
    },

    //【职位】点击职位
    clickJobs(item,index){
      //更新query的部分值
      let { id, job_post } = item.recruit_info;
      let query = {
        keyword: job_post,
        city: item.cities ? item.cities[0] : '',
        education: item.display_degree ? (item.display_degree==='学历不限' ? '' : this.jobType[item.display_degree])  : '',
        workYear: item.display_experience ? (item.display_experience==='经验不限' ? '' : (item.display_experience==='1年以下' ? '应届生' : item.display_experience) )  : '',
        job_id: id,
        index
      }
      this.clickLeftJobs(query)
    },
    //左侧职位点击
    clickLeftJobs(query){
      let { keyword, city, education, workYear, job_id, index } = query;
      let schoolType='不限'
      //整理keywords
      let keywords = keyword.split(',').filter(item=>item);
      this.keywords = keywords;
      this.keywordsBat = [...keywords];
      //整理分页
      this.pageNo = 1;
      //整理工作经验
      this.selectedeXperience = workYear ==='不限' ? [] : workYear.split(',').filter(item=>item);
      //整理院校
      this.selectedSchool = schoolType ==='不限' ? [] : schoolType.split(',').filter(item=>item);
      //整理学历
      console.log(education,"==================>education")
      this.selectedEducation = education ==='不限' ? [] : education.split(',').filter(item=>item);

      //同步顶部详情token
      this.updateResumeDetailToken('');

      //增加历史记录
      let searchHistory = localStorage.getItem('searchHistory');
      this.searchHistory =  searchHistory ? JSON.parse(searchHistory) : [];

      //整理城市
      this.city = checkCity(city) ? city : '全国';

      //是否自动收藏
      this.favoritesId = '';
      // 期望默认的职位id
      this.job_id = job_id;

      //整理uri格式
      this.encodeURI();

      //保存点击的第几个职位
      this.searchPositionIndex = index;
      //获取搜索列表
      this.getList();
    },
    // 热门搜索
    clickHot(item){
      // 清空搜索
      this.keywords = [item];
      this.keywordsBat = [item];
      this.searchVal = '';
      this.job_id = '';
      //重置参数，请求接口
      this.resetQuery();
      this.showSearchJob = false;
    },
    //历史搜索
    clickHistory(item){
      // 清空搜索
      this.keywords = item.keywords;
      this.keywordsBat = item.keywords;
      this.searchVal = '';
      this.job_id = '';
      //重置参数，请求接口
      this.resetQuery();
      this.showSearchJob = false;
    },
    //清空历史消息
    clearHistory(){
      this.searchHistory = [];
      localStorage.setItem('searchHistory','[]');
    },
    //【手机号】同意获取手机号&&更新脱敏数据
    confirmGetPhone(profile_data){
      let { username, phone, email } = profile_data;

      let { profile } = this.resumeDetail.resume.info;
      profile.username = username;
      profile.phone = phone;
      profile.email = email;
      this.resumeDetail.hr_permission_state = 'passed';
      //同步状态到vuex中
      this.updateResumeDetail(this.resumeDetail)

      let resumeList = this.resumeListData.resumes;
      if(!resumeList){
        return false;
      }
      let detailIndex = '';
      let detailItem = {};
      //匹配当前简历在列表中是否存在
      resumeList.forEach((item,index)=>{
        let {token} = item.resume._source;
        if(token === this.resumeDetailToken){
          detailIndex = index;
          detailItem = item;
        }
      })

      if(detailIndex !==''){
        detailItem.hr_permission_state = 'passed';
        this.$set(this.resumeListData.resumes,detailIndex,detailItem)
      }
    },

    //获取body高度
    getBodyClient(){
      this.updagreBodyClient(document.body.clientHeight);
    },
    //退出登录
    async sign_out(){
      if(confirm('确定退出登录么？')){
        updateJWT({ jwt:'', jwt_timestamp:parseInt(new Date().getTime()/1000) });
        toLogin();
      }
    },
    scrollTop(){
      if(!this.scrollTopNumber){
        this.scrollTopNumber = document.documentElement.scrollTop/10
      };
      //参数i表示间隔的幅度大小，以此来控制速度
      document.documentElement.scrollTop-=this.scrollTopNumber;
      if (document.documentElement.scrollTop>0) {
        var c=setTimeout(()=>this.scrollTop(this.scrollTopNumber),16);
      }else {
        this.scrollTopNumber = 0
        clearTimeout(c);
      }
      // scrollTo(0,0)
    },
    // 去招聘道具页面
    toProp(){
      this.$router.push({name:'props'})
    },

  },
  watch: {
    //监听路由，只要路由有变化(路径，参数等变化)都有执行下面的函数
    $route: {
      handler: function (val, oldVal) {
        this.created();
      },
      deep: true
    },
    // keywordsBat:{
    //   handler: function (val, oldVal) {},
    //   deep: true
    // },
    windowScrollTop(val, oldVal){
      // 重新获取body高度
      this.getBodyClient()
      // // body高度 - 浏览器窗口高度
      let maxScrollTop = this.bodyClientHeight - this.windowInnerHeight;
      let maxPage = Math.ceil(this.listOptions.total_count/15)
      //监控 顶部头高度，控制左侧搜索框高度

      if(this.windowScrollTop - this.showSearchJobScrollHeight >= 100 && this.showSearchJob){
        this.showSearchJob = false;
        this.$refs.searchInput.blur();
      }
      if(val>=65){
        // console.log('scrollHeaderHeight=>',this.scrollHeaderHeight)
        this.scrollHeaderHeight = this.$refs.scrollHeader.offsetHeight
      }
      if(maxScrollTop-val<250 && this.isQueryEnd && !this.isLoading && this.pageNo<maxPage){
        this.pageNo = this.pageNo+1;
        this.getList('scroll');
      }
    },
    //监听分页变化
    listPageNumber:{
      handler: function (val, oldVal) {
        // 翻上一页 || 下一页
        if(val < this.listOptions.page || val > this.listOptions.page){
          this.pageChange(this.listPageNumber)
        }
      },
      deep: true
    },
  },

}
</script>
<style lang="scss" scoped>
@import './List.scss';
.searchFilter {
  box-shadow: none;
}
</style>
